export default __webpack_public_path__ + "static/media/User-survey-vegan-page.cc4e0459.jpg";